// extracted by mini-css-extract-plugin
export default {"gray02":"#D8DDE1","blue07":"#00A0FE","normalSizeValue":"0.875rem","button":"DownloadMenuLight__button___A5ml0"};